<template>
  <div>
    <Navbar
      :isLogin="isLogin"
      :activePage="activePage"
      @changePage="changePage"
      @logout="logout"
    ></Navbar>

    <LoginPage
      v-if="activePage === 'LoginPage'"
      @login="login"
      @changePage="changePage"
      @loginGoogle="loginGoogle"
    ></LoginPage>

    <Dashboard
      v-else-if="activePage === 'Dashboard'"
      :listTask="listTask"
      @changePage="changePage"
      @addTask="addData"
      @deleteData="deleteData"
      @fetchDetail="fetchDetail"
      :detailTask="detailTask"
      @editTask="editTask"
    ></Dashboard>
    <AddTask v-else-if="activePage === 'AddTask'" @addData="addData"></AddTask>

    <RegisterPage v-else @toRegister="register"></RegisterPage>
  </div>
</template>

<script>
import LoginPage from "./views/Login";
import RegisterPage from "./views/Register";
import Dashboard from "./views/Dashboard";
import AddTask from "./views/AddTask";
import Navbar from "./components/Navbar";
import axios from "./api/axios";
export default {
  name: "App",
  data() {
    return {
      message: "Hello World",
      activePage: "Dashboard",
      isLogin: false,
      listTask: [],
      detailTask: {
        id: "",
        title: "",
        category: "",
      },
    };
  },
  components: {
    LoginPage,
    Dashboard,
    RegisterPage,
    AddTask,
    Navbar,
  },
  created() {
    if (localStorage.getItem("access_token")) {
      this.activePage = "Dashboard";
      this.fetchData();
    } else {
      this.changePage("LoginPage");
    }
  },
  methods: {
    changePage(page) {
      this.activePage = page;
    },
    login(data) {
      axios
        .post("/login", data)
        .then((user) => {
          localStorage.setItem("access_token", user.data.access_token);
          this.fetchData();
          this.changePage("Dashboard");
        })
        .catch((err) => console.log(err));
    },
    register(data) {
      axios
        .post("/register", data)
        .then((user) => {
          this.changePage("LoginPage");
        })
        .catch((err) => console.log(err));
    },
    fetchData() {
      axios({
        method: "GET",
        url: "https://kanban-server-frs.herokuapp.com/tasks",
        headers: {
          access_token: localStorage.getItem("access_token"),
        },
      })
        .then((tasks) => {
          console.log(tasks.data, "<< ini tasks");
          this.listTask = tasks.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addData({ title, category }) {
      axios({
        url: "https://kanban-server-frs.herokuapp.com/tasks",
        method: "POST",
        data: {
          title,
          category,
        },
        headers: {
          access_token: localStorage.getItem("access_token"),
        },
      }).then((newTask) => {
        this.fetchData(newTask.data);
        this.changePage("Dashboard");
        console.log(newTask, "<< add newTask");
      });
    },
    deleteData(id) {
      //   console.log(id, '<< app');
      axios({
        url: `https://kanban-server-frs.herokuapp.com/tasks/${id}`,
        method: "DELETE",
        headers: {
          access_token: localStorage.getItem("access_token"),
        },
      })
        .then((user) => {
          this.fetchData();
          console.log("hasbeen deleted");
          this.changePage("Dashboard");
        })
        .catch((err) => console.log(err));
    },
    fetchDetail(id) {
      axios({
        method: "GET",
        url: `https://kanban-server-frs.herokuapp.com/tasks/${id}`,
        headers: {
          access_token: localStorage.getItem("access_token"),
        },
      }).then((taskDetail) => {
        this.detailTask = taskDetail.data.task;
      });
    },
    editTask() {
      console.log(this.detailTask.id, "<<< id edit");
      console.log(this.detailTask.title, "<<< title edit");
      axios({
        method: "PUT",
        url: `https://kanban-server-frs.herokuapp.com/tasks/${this.detailTask.id}`,
        headers: {
          access_token: localStorage.getItem("access_token"),
        },
        data: {
          title: this.detailTask.title,
          category: this.detailTask.category,
        },
      }).then((editTask) => {
        this.fetchData(editTask);
        this.changePage("Dashboard");
      });
    },
    logout() {
      localStorage.clear();
      this.changePage("LoginPage");
    },
    loginGoogle(token) {
      axios({
        method: "POST",
        url: `https://kanban-server-frs.herokuapp.com/googleLogin`,
        headers: {
          token,
        },
      }).then((user) => {
        console.log(user.data.access_token);
        localStorage.setItem("access_token", user.data.access_token);
        // this.changePage("Dashboard");
        // this.fetchData();
        // const auth2 = gapi.auth2.getAuthInstance();
        // auth2.signOut().then(function () {
        //   console.log("User signed out.");
        // });
      });
    },
  },
};
</script>

<style>
</style>